export default (pointTime, frame) => {
  return {
    namespace: "/finding",
    stale: 1,
    expire: 1,
    queryParams: [
      {
        refName: "endTime",
        field: "created",
        operator: "lt",
        value: pointTime.utc().format("YYYY-MM-DDTHH:mm:ss.SSS999"),
      },
      {
        refName: "startTime",
        field: "created",
        operator: "gt",
        value: pointTime
          .utc()
          .subtract(1, `${frame}s`)
          .format("YYYY-MM-DDTHH:mm"),
      },
    ],
    resultParams: {
      orderBy: [{ key: "created", value: -1 }],
      outputFields: [
        "owners",
        "id",
        "created",
        "orgId",
        "priority",
        "shortId",
        "name",
        "analysis",
        "type",
        "category",
        "confirmation",
        "confirmationCompleted",
        "escalation",
        "escalationCompleted",
        "mitigation",
        "mitigationCompleted",
      ],
    },
  };
};
